import { Record, RecordOf } from 'immutable';



export type SignInWithSecretRequest = RecordOf<SignInWithSecretRequestProperties>;


export interface SignInWithSecretRequestProperties {
  username: string;
  password: string;
  rememberUsername: boolean;
  secretQuestion: string;
  secretAnswer: string;
  skip2fvSetUp: boolean;
  isEncoded: boolean;
}


export class SignInWithSecretRequestFactory {
  static readonly create = Record<SignInWithSecretRequestProperties>({
    username: null,
    password: null,
    rememberUsername: false,
    secretQuestion: null,
    secretAnswer: null,
    skip2fvSetUp: false,
    isEncoded: false
  });
}
